import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { RoundedIconButton } from 'app/shared/components/rounded-icon-button/rounded-icon-button';
import { SkinningService } from '@core/skin';
import { PlayerService } from 'app/features/player/data-access/player.service';
import { getThumbnailForPosition, getThumbnailImage$, IThumbnailConfig } from './player-controls-seek-preview-helper';
import { DatePipe } from '@angular/common';
import { catchError, concat, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'player-controls-seek-preview',
  imports: [
    RoundedIconButton,
    DatePipe,
  ],
  templateUrl: './player-controls-seek-preview.html',
  styleUrl: './player-controls-seek-preview.scss'
})
export class PlayerControlsSeekComponent {
  public skinning = inject(SkinningService);
  private playerService = inject(PlayerService);

  public thumbnailConfig = input<IThumbnailConfig>();
  public seekPosition = input<number>();

  public previewUrl = toSignal(
    toObservable(
      computed(() => ({
        position: this.seekPosition(),
        config: this.thumbnailConfig(),
        duration: this.playerService.getDuration()
      }))
    ).pipe(
      switchMap(({ position, config, duration }) => {
        if (position == null || !config) {
          return of(null);
        }

        const thumb = getThumbnailForPosition(config, position, duration);
        if (!thumb) {
          return of(null);
        }

        // Return null first to ensure the old thumbnail is cleared while the new one loads
        return concat(
          of(null),
          getThumbnailImage$(thumb).pipe(
            map(canvas => canvas.toDataURL('image/jpeg')),
            catchError(() => of(null))
          )
        );
      })
    ),
    { initialValue: null }
  );

}
